import { render, staticRenderFns } from "./Places.vue?vue&type=template&id=308e480d"
import script from "./Places.vue?vue&type=script&lang=js"
export * from "./Places.vue?vue&type=script&lang=js"
import style0 from "./Places.vue?vue&type=style&index=0&id=308e480d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports